<template lang="pug">
  .layout
    y-dialog(v-if="showModal" v-model='showModal' scrollable max-width='600px' persistent)
      v-card
        v-card-title.px-4
          v-layout
            div.h6.basic800--text Images
            v-spacer
            v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddImageDialog = !showAddImageDialog")
              v-icon.mr-1(small) mdi-plus
              | Add image

        v-divider.basic300
        v-card-text.px-4.pb-0
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            v-layout.my-6(v-if="images.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption Images not found or empty
            .items-layout.pt-4(v-else)
              v-row(no-gutters)
                template(v-for='(image, idx) in images')
                  v-col(cols="4" style="padding: 1px")
                    v-card.pa-1(flat tile :color="image.selected ? 'info400' : ''" @click="clickImages(idx)")
                      v-img(:src="image.document.file" aspect-ratio="1")
                        template(v-slot:placeholder)
                          v-row(class="fill-height ma-0" align="center" justify="center")
                            v-progress-circular(indeterminate color="grey")

          y-pagination.my-4(v-model="page" :pageSize="fetchCount" :count="count")
          
        v-card-actions
          v-spacer
          template(v-if="images.filter(f => f.selected === true).length > 0")
            v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="danger500" text small @click="openDeleteDialog = true")
              eva-icon.mr-2(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="12" width="12" style="margin-top: 1px")
              | Delete selected
          v-btn.ma-0(color='white', text @click='showModal = false')
            .button-Aa-small.info500--text Close
    
    .modals
      AddNewDocument(v-if="showAddImageDialog" :open.sync="showAddImageDialog" :expenseId="expenseId" @added="handleAddItem")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 Delete image
          v-card-text.p2.primary500--text.px-4
            div(v-if="images.filter(f => f.selected === true).length > 1") Are you sure you want to delete these images? These images will be deleted permanently.
            div(v-else) Are you sure you want to delete this image? This image will be deleted permanently.
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text Cancel
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading")
              .button-AA-small.basic100--text Delete

</template>

<script>
import { mapGetters } from "vuex"
import AddNewDocument from '@/components/yezzabook/dialogs/expense/AddNewDocument.vue'
export default {
  name: 'ManageDocuments',
  props: ['open', 'expenseId'],
  components: { AddNewDocument },
  data: () => ({
    isLoading: false,
    isFetching: false,
    fetchCount: 11,
    page: 1,
    count: 0,
    images: [],
    showAddImageDialog: false,
    openDeleteDialog: false,
    deleteList: [],
    doneDelete: []
  }),
  mounted () {
    this.fetchImages(1)
  },
  computed: {
    ...mapGetters({
      company: "getCompany",
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchImages(val)
      }
    },
    mainImageFile: {
      deep: true,
      handler (val) {
        this.$emit('updateImage', [this.mainImageFileUrl, val])
      }
    },
    doneDelete (val) {
      if (val.length > 0 && val.length === this.deleteList.length) {
        this.isLoading = false
        this.openDeleteDialog = false
        setTimeout(() => {
          this.clearDelete()
        }, 1000)
      }
    }
  },
  methods: {
    fetchImages(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/books/${this.company.slug}/expenses/${this.expenseId}/documents?ordering=-id&page=${page}&page_size=${this.fetchCount}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.images = response.data.results.map(m => { return { ...m, selected: false}})
        this.count = response.data.count
      })
      .catch(() => {})
    },
    handleAddItem (item) {
      this.images.push(item)
      this.$emit('updated')
    },
    clickImages (val) {
      this.$set(this.images[val], 'selected', !this.images[val].selected)
    },
    startDelete () {
      this.isLoading = true
      this.deleteList = this.images.filter(f => f.selected === true)
      this.deleteList.forEach(o => {
        this.axios.delete(`/books/${this.company.slug}/expenses/${this.expenseId}/documents/${o.id}`)
          .then(() => {
            this.$emit('updated')
            this.images = this.images.filter(f => f.id !== o.id)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.doneDelete.push('o.id')
          })
      })
        
    },
    clearDelete () {
      this.deleteList = [],
      this.doneDelete = []
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>

<i18n>
{
  "en": {
    "option": {
      "placeholder": "Write option name here"
    },
    "add": "Update",
    "add": "Create"
  }
}
</i18n>
